import { render, staticRenderFns } from "./QueryConfig.vue?vue&type=template&id=775fc4d4&scoped=true&"
import script from "./QueryConfig.vue?vue&type=script&lang=js&"
export * from "./QueryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775fc4d4",
  null
  
)

export default component.exports